import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  dashboard: {
    id: 'portal.views.dashboard.heading.dashboard',
    defaultMessage: 'Dashboard',
    description: 'Dashboard heading',
  },
  viewPublicProfile: {
    id: 'portal.views.dashboard.link.viewPublicProfile',
    defaultMessage: 'View Public Profile',
    description: 'View public profile link',
  },
  viewCohorts: {
    id: 'portal.views.dashboard.link.viewCohorts',
    defaultMessage: 'Cohorts',
    description: 'Dashboard entry point link to the cohorts area',
  },
  myPersonalInformation: {
    id: 'portal.views.dashboard.section.myPersonalInformation',
    defaultMessage: 'My Personal Information',
    description: 'My Personal Information section title',
  },
  certificateHelper: {
    id: 'portal.views.dashboard.helper.certificate',
    defaultMessage: 'Click on icons to access downloadable PDF certificate. Greyed certificates are still to be earned.',
    description: 'Helper text for certificates',
  },
  badgeHelper: {
    id: 'portal.views.dashboard.helper.badge',
    defaultMessage: 'Hover over a badge to see details',
    description: 'Helper text for badges',
  },
  badges: {
    id: 'portal.views.dashboard.section.badges',
    defaultMessage: 'Badges',
    description: 'Badges title',
  },
  modulesCompleted: {
    id: 'portal.views.dashboard.section.modulesCompleted',
    defaultMessage: 'Modules Completed',
    description: 'Modules Completed title',
  },
  editButtonAlt: {
    id: 'portal.views.dashboard.button.edit.alt',
    defaultMessage: 'Edit',
    description: 'Edit button alt text',
  },
  emailLabel: {
    id: 'portal.views.dashboard.label.email',
    defaultMessage: 'Email',
    description: 'Profile email label',
  },
  bioLabel: {
    id: 'portal.views.dashboard.label.bio',
    defaultMessage: 'Bio',
    description: 'Profile bio label',
  },
  linksLabel: {
    id: 'portal.views.dashboard.label.links',
    defaultMessage: 'Links',
    description: 'Profile links label',
  },
  profileAccessLabel: {
    id: 'portal.views.dashboard.label.profile',
    defaultMessage: 'Profile',
    description: 'Profile access label',
  },
  profileAccessValue: {
    id: 'portal.views.dashboard.value.profile',
    defaultMessage: 'Public',
    description: 'Profile access value',
  },
  xSocialLabel: {
    id: 'portal.views.dashboard.label.x',
    defaultMessage: 'X.com',
    description: 'Profile X (formerly Twitter) label',
  },
  linkedInLabel: {
    id: 'portal.views.dashboard.label.linkedin',
    defaultMessage: 'LinkedIn',
    description: 'Profile LinkedIn label',
  },
  profileImageAlt: {
    id: 'portal.views.dashboard.alt.profileImage',
    defaultMessage: 'Profile image',
    description: 'Profile image alt text',
  },
  fileSizeExceeded: {
    id: 'portal.hooks.utils.validation.fileSizeExceeded',
    defaultMessage: 'File size exceeds 1 MB. Please select a smaller file.',
    description: 'File size validation message',
  },
});

export default messages;
